module.exports = __webpack_public_path__ + "static/media/extra-activities.2e67b421.svg";